'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _htmlToReact = require('html-to-react');

var _htmlToReact2 = _interopRequireDefault(_htmlToReact);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _appBadges = require('../../../atoms/app-badges');

var _appBadges2 = _interopRequireDefault(_appBadges);

var _button = require('../../../atoms/button');

var _button2 = _interopRequireDefault(_button);

var _heading = require('../../../atoms/heading');

var _heading2 = _interopRequireDefault(_heading);

var _mediaButton = require('../../../atoms/media-button');

var _mediaButton2 = _interopRequireDefault(_mediaButton);

var _themeManager = require('../../../../utilities/themeManager');

var _themeManager2 = _interopRequireDefault(_themeManager);

var _breakpoints = require('../../../../utilities/breakpoints');

var _breakpoints2 = _interopRequireDefault(_breakpoints);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var htmlToReactParser = new _htmlToReact2.default.Parser();

var ORGANISM_NAME = 'home-hero';

var getAlignment = function getAlignment(textAlign) {
  var alignment = {
    left: ORGANISM_NAME + '__container col-xs-12 col-lg-8 text-xs-left',
    center: ORGANISM_NAME + '__container col-xs-12 col-lg-8 center-block text-xs-center'
  };
  return alignment[textAlign || 'center'];
};

var renderHeadline = function renderHeadline(headline) {
  if (headline) {
    return _react2.default.createElement(
      _heading2.default,
      { className: ORGANISM_NAME + '__headline' },
      htmlToReactParser.parse(headline.text)
    );
  }
  return null;
};

var renderParagraph = function renderParagraph(paragraph) {
  if (paragraph && paragraph.text) {
    return _react2.default.createElement(
      'p',
      { className: ORGANISM_NAME + '__paragraph' },
      htmlToReactParser.parse(paragraph.text)
    );
  }
  return null;
};

var renderMediaButton = function renderMediaButton(mediaButton, color) {
  if (mediaButton && mediaButton.text) {
    return _react2.default.createElement(
      _mediaButton2.default
      // adding null to prevent empty id from being added to DOM
      ,
      { id: mediaButton.id || null,
        color: color || mediaButton.color,
        className: ORGANISM_NAME + '__mediabtn',
        fpti: 'HPHero-MediaBtn-' + (mediaButton.fpti || mediaButton.text),
        'data-video-id': mediaButton['data-video-id']
      },
      mediaButton.text
    );
  }
  return null;
};

var renderCta = function renderCta(cta, color) {
  if (cta && cta.text) {
    var targetValue = cta.target || '_self';
    return _react2.default.createElement(
      _button2.default
      // adding null to prevent empty id from being added to DOM
      ,
      { id: cta.id || null,
        href: cta.href,
        color: color || cta.color || null,
        className: ORGANISM_NAME + '__btn',
        fpti: 'HPHero-' + (cta.type || 'cta') + '-' + (cta.fpti || cta.text),
        target: targetValue
      },
      cta.text
    );
  }
  return null;
};

var renderHatchText = function renderHatchText(hatchText) {
  if (hatchText && hatchText.text) {
    return _react2.default.createElement(
      'p',
      { className: ORGANISM_NAME + '__hatch-text pp-sans-small-regular' },
      htmlToReactParser.parse(hatchText.text)
    );
  }
  return null;
};

var renderBadge = function renderBadge(content, clientInfo, isCentered) {
  var appBadgeContent = {
    clientInfo: clientInfo,
    ios: content.ios,
    android: content.android
  };
  var classes = isCentered ? ORGANISM_NAME + '__app-badge-wrapper--center' : ORGANISM_NAME + '__app-badge-wrapper';

  return _react2.default.createElement(
    'div',
    { className: classes },
    _react2.default.createElement(_appBadges2.default, appBadgeContent)
  );
};

var HomePageHero = function (_React$Component) {
  _inherits(HomePageHero, _React$Component);

  function HomePageHero(props) {
    _classCallCheck(this, HomePageHero);

    var _this = _possibleConstructorReturn(this, (HomePageHero.__proto__ || Object.getPrototypeOf(HomePageHero)).call(this, props));

    _this.getAlignment = getAlignment;
    _this.renderHeadline = renderHeadline;
    _this.renderParagraph = renderParagraph;
    _this.renderMediaButton = renderMediaButton;
    _this.renderCta = renderCta;
    _this.renderBadge = renderBadge;
    _this.renderHatchText = renderHatchText;
    _this.handleResize = _this.handleResize.bind(_this);
    _this.state = {
      isMobile: false
    };
    return _this;
  }

  _createClass(HomePageHero, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      window.addEventListener('resize', this.handleResize);
      this.handleResize();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.handleResize);
    }
  }, {
    key: 'handleResize',
    value: function handleResize() {
      var newWindowWidth = Math.min(this.organismRef.ownerDocument.defaultView.innerWidth, this.organismRef.ownerDocument.documentElement.clientWidth, this.organismRef.ownerDocument.body.clientWidth);
      if (newWindowWidth >= _breakpoints2.default.medium) {
        if (this.state.isMobile) {
          this.setState({
            isMobile: false
          });
        }
      } else if (!this.state.isMobile) {
        this.setState({
          isMobile: true
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var theme = this.props.config.theme || 'theme-background-image-dark';
      var newProps = (0, _themeManager2.default)({ content: this.props.content }, theme);
      var content = newProps.content;
      var _props = this.props,
          config = _props.config,
          className = _props.className,
          viewport = _props.viewport,
          clientInfo = _props.clientInfo;
      var headline = content.headline,
          paragraph = content.paragraph,
          mediaButton = content.mediaButton,
          primaryCta = content.primaryCta,
          secondaryCta = content.secondaryCta,
          hatchText = content.hatchText;


      var sectionClasses = (0, _classnames2.default)(ORGANISM_NAME + '-organism', className);

      var heroClasses = (0, _classnames2.default)(ORGANISM_NAME, config.height || 'tall', theme);

      var backgroundImage = config.backgroundImage && (config.backgroundImage[viewport] || config.backgroundImage.url);
      var backgroundPosition = config.backgroundImage && config.backgroundPosition;
      var backgroundImageStyle = backgroundImage ? {
        backgroundImage: 'url(' + backgroundImage + ')',
        backgroundPosition: '' + (backgroundPosition || 'center')
      } : null;
      var isCentered = config.deviceImageSize === 'large';

      return _react2.default.createElement(
        'section',
        {
          ref: function ref(c) {
            _this2.organismRef = c;
          },
          id: config.id ? config.id : null,
          className: sectionClasses,
          'data-building-block': 'organism'
        },
        _react2.default.createElement(
          'div',
          { className: heroClasses, style: backgroundImageStyle },
          _react2.default.createElement(
            'div',
            { className: 'container' },
            _react2.default.createElement(
              'div',
              { className: 'row' },
              _react2.default.createElement(
                'div',
                { className: getAlignment(config.textAlign) },
                this.state.isMobile && paragraph && paragraph.text ? _react2.default.createElement(
                  'div',
                  null,
                  renderHeadline(headline)
                ) : _react2.default.createElement(
                  'div',
                  null,
                  renderHeadline(headline),
                  renderParagraph(paragraph),
                  renderMediaButton(mediaButton),
                  renderCta(primaryCta),
                  renderCta(secondaryCta),
                  this.renderBadge(content, clientInfo, isCentered),
                  renderHatchText(hatchText)
                )
              )
            )
          )
        ),
        this.state.isMobile && paragraph && paragraph.text && _react2.default.createElement(
          'div',
          { className: 'below-' + ORGANISM_NAME },
          _react2.default.createElement(
            'div',
            { className: 'container' },
            _react2.default.createElement(
              'div',
              { className: 'row' },
              _react2.default.createElement(
                'div',
                { className: getAlignment(config.textAlign) },
                renderParagraph(paragraph),
                renderMediaButton(mediaButton, 'outline-blue'),
                renderCta(primaryCta),
                renderCta(secondaryCta, 'outline-blue'),
                this.renderBadge(content, clientInfo, isCentered),
                renderHatchText(hatchText)
              )
            )
          )
        )
      );
    }
  }]);

  return HomePageHero;
}(_react2.default.Component);

exports.default = HomePageHero;


HomePageHero.propTypes = {
  viewport: _propTypes2.default.string,
  clientInfo: _propTypes2.default.shape({
    client_os_type: _propTypes2.default.string,
    client_is_mobile: _propTypes2.default.bool,
    client_type: _propTypes2.default.string
  }),
  config: _propTypes2.default.shape({
    id: _propTypes2.default.string,
    backgroundImage: _propTypes2.default.shape({
      url: _propTypes2.default.string.isRequired,
      portable: _propTypes2.default.string.isRequired,
      mobile: _propTypes2.default.string.isRequired
    }).isRequired,
    theme: _propTypes2.default.oneOf(['theme-background-image-dark', 'theme-background-image-light', 'theme-new-money']),
    height: _propTypes2.default.oneOf(['short', 'tall']),
    backgroundPosition: _propTypes2.default.oneOf(['left', 'center', 'right']),
    textAlign: _propTypes2.default.oneOf(['center', 'left']).isRequired
  }),
  content: _propTypes2.default.shape({
    headline: _propTypes2.default.shape({
      text: _propTypes2.default.string.isRequired
    }).isRequired,
    paragraph: _propTypes2.default.shape({
      text: _propTypes2.default.string.isRequired
    }),
    mediaButton: _propTypes2.default.shape({
      text: _propTypes2.default.string.isRequired,
      'data-video-id': _propTypes2.default.string.isRequired,
      fpti: _propTypes2.default.string,
      id: _propTypes2.default.string
    }),
    primaryCta: _propTypes2.default.shape({
      href: _propTypes2.default.string.isRequired,
      text: _propTypes2.default.string.isRequired,
      id: _propTypes2.default.string,
      fpti: _propTypes2.default.string,
      target: _propTypes2.default.oneOf(['_self', '_blank'])
    }).isRequired,
    secondaryCta: _propTypes2.default.shape({
      href: _propTypes2.default.string.isRequired,
      text: _propTypes2.default.string.isRequired,
      id: _propTypes2.default.string,
      fpti: _propTypes2.default.string,
      target: _propTypes2.default.oneOf(['_self', '_blank'])
    }),
    ios: _propTypes2.default.shape({
      href: _propTypes2.default.string.isRequired,
      fpti: _propTypes2.default.string
    }),
    android: _propTypes2.default.shape({
      store: _propTypes2.default.oneOf(['google', 'android-store']),
      href: _propTypes2.default.string.isRequired,
      fpti: _propTypes2.default.string
    }),
    hatchText: _propTypes2.default.shape({
      text: _propTypes2.default.string.isRequired
    })
  }),
  className: _propTypes2.default.string
};

HomePageHero.defaultProps = {
  viewport: 'dedicated',
  clientInfo: {
    client_os_type: 'ios',
    client_is_mobile: true,
    client_type: 'dedicated'
  },
  config: {
    id: '',
    textAlign: 'center',
    theme: 'theme-background-image-dark',
    backgroundImage: {
      url: 'https://www.paypalobjects.com/digitalassets/c/website/marketing/na/us/home/hero-small-business.jpg',
      portable: 'https://www.paypalobjects.com/digitalassets/c/website/marketing/na/us/home/hero-small-business-medium.jpg',
      mobile: 'https://www.paypalobjects.com/digitalassets/c/website/marketing/na/us/home/hero-small-business-small.jpg'
    },
    backgroundPosition: 'center',
    height: 'tall'
  },
  content: {
    headline: {
      text: '21 characters per line - 2 lines maximum.'
    },
    paragraph: {
      text: 'In mobile and tablet views, align text to optimize contrast with ' + 'background image. 152 characters maximum.'
    },
    mediaButton: {
      id: '',
      text: '25 characters maximum',
      'data-video-id': 'lkz4GZgyb9o'
    },
    primaryCta: {
      id: '',
      href: '#',
      text: '29 characters maximum',
      target: '_self'
    },
    secondaryCta: {
      id: '',
      href: '#',
      text: '29 characters maximum',
      target: '_self'
    },
    ios: {
      href: 'https://app.adjust.com/vlx5gy',
      fpti: "home-hero"
    },
    android: {
      store: 'google',
      href: 'https://app.adjust.com/vxullh',
      fpti: "home-hero"
    },
    hatchText: {
      text: '34 characters maximum per line'
    }
  },
  className: ''
};


//////////////////
// WEBPACK FOOTER
// /donatenodeweb-ci-2793/workspace/donate-gro-release/~/marketing-components/dist/components/organisms/homepage-hero/jsx/HomePageHero.js
// module id = 574
// module chunks = 4